<template>
  <SogCard>
    <SogCardTitle>
      {{ props.insurance.insuranceNumber }}
    </SogCardTitle>
    <SogCardContent>
      <SogDataLabel
        :value="props.insurance.evb"
      />
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import Insurance from "@/shared/model/Insurance";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";

interface Props {
  insurance:Insurance
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  }
)




</script>

<style scoped>

</style>
